import React from "react"

export default function Twitter() {
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 29 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9724 23.4845C9.76165 23.4845 8.51549 23.3865 7.26185 23.19C5.05382 22.8435 2.81867 21.6886 2.18619 21.3427L0.527344 20.4358L2.32332 19.8451C4.28656 19.1996 5.48082 18.7991 6.95917 18.172C5.47889 17.4551 4.33804 16.1656 3.78886 14.4986L3.37105 13.2303L3.71367 13.2826C3.38878 12.9551 3.13224 12.6228 2.93338 12.3205C2.22614 11.2463 1.85169 9.93371 1.93136 8.80887L2.00997 7.70176L2.67278 7.95851C2.39317 7.43048 2.1911 6.86657 2.07234 6.27552C1.78291 4.83412 2.02513 3.3028 2.75459 1.96371L3.33196 0.903808L4.10414 1.83128C6.54627 4.76492 9.63947 6.50515 13.3107 7.01459C13.1607 5.98096 13.2731 4.98343 13.645 4.08929C14.0779 3.04818 14.8482 2.16535 15.8718 1.53608C17.0086 0.837378 18.3872 0.498815 19.7536 0.582761C21.2033 0.671834 22.5196 1.21503 23.5649 2.15467C24.0755 2.02203 24.4516 1.88041 24.96 1.68902C25.2659 1.57388 25.6128 1.44316 26.0468 1.29364L27.6463 0.742537L26.6032 3.72146C26.672 3.71569 26.7429 3.71078 26.8171 3.70758L28.525 3.63025L27.5155 5.00992C27.4577 5.08895 27.4429 5.11138 27.4224 5.14235C27.341 5.26496 27.2398 5.41748 25.8541 7.26771C25.5072 7.73102 25.334 8.33445 25.3663 8.96715C25.4891 11.3715 25.1941 13.5468 24.489 15.4325C23.8221 17.2165 22.7887 18.7472 21.4178 19.9821C19.7214 21.5098 17.5582 22.5558 14.9881 23.0907C13.7274 23.353 12.3736 23.4845 10.9724 23.4845Z"
        fill="#3870DE"
      />
    </svg>
  )
}
